import { QueryClient } from '@tanstack/react-query';
import {
  EnterpriseListFilter,
  EnterpriseTeam,
  EnterpriseWorkspace
} from '../../../api/enterprise/enterprise.api';

export function workspaceSlugQueryKey(
  organizationId: string,
  slug: string,
  filter: EnterpriseListFilter
) {
  return [
    'enterprise',
    'workspace',
    'slug',
    organizationId,
    slug,
    filter
  ] as const;
}

export function workspaceIdQueryKey(
  organizationId: string,
  id: number,
  filter: EnterpriseListFilter
) {
  return ['enterprise', 'workspace', 'id', organizationId, id, filter] as const;
}

export function teamByWorkspaceSlugQueryKey(
  organizationId: string,
  workspaceSlug: string,
  teamSlug: string,
  filter: EnterpriseListFilter
) {
  return [
    'enterprise',
    'team',
    'by-workspace-slug',
    organizationId,
    workspaceSlug,
    teamSlug,
    filter
  ] as const;
}

export function teamSlugQueryKey(
  organizationId: string,
  workspaceId: number,
  teamSlug: string,
  filter: EnterpriseListFilter
) {
  return [
    'enterprise',
    'team',
    'slug',
    organizationId,
    workspaceId,
    teamSlug,
    filter
  ] as const;
}

export function teamIdQueryKey(
  organizationId: string,
  teamId: number,
  filter: EnterpriseListFilter
) {
  return ['enterprise', 'team', 'id', organizationId, teamId, filter] as const;
}

export function seedEnterpriseWorkspaceCaches(
  queryClient: QueryClient,
  workspace: EnterpriseWorkspace,
  filter: EnterpriseListFilter
) {
  queryClient.setQueryData(
    workspaceSlugQueryKey(workspace.organizationId, workspace.slug, filter),
    workspace
  );
  queryClient.setQueryData(
    workspaceIdQueryKey(workspace.organizationId, workspace.id, filter),
    workspace
  );
}

export function seedEnterpriseTeamCaches(
  queryClient: QueryClient,
  team: EnterpriseTeam,
  organizationId: string,
  filter: EnterpriseListFilter
) {
  queryClient.setQueryData(
    teamSlugQueryKey(organizationId, team.workspaceId, team.slug, filter),
    team
  );
  queryClient.setQueryData(
    teamIdQueryKey(organizationId, team.id, filter),
    team
  );
}

export function seedEnterpriseWorkspaceListCaches(
  queryClient: QueryClient,
  workspaces: EnterpriseWorkspace[],
  filter: EnterpriseListFilter
) {
  for (const workspace of workspaces) {
    seedEnterpriseWorkspaceCaches(queryClient, workspace, filter);
  }
}

export function seedEnterpriseTeamListCaches(
  queryClient: QueryClient,
  teams: EnterpriseTeam[],
  organizationId: string,
  filter: EnterpriseListFilter
) {
  for (const team of teams) {
    seedEnterpriseTeamCaches(queryClient, team, organizationId, filter);
  }
}
